import { render, staticRenderFns } from "./AiJdMatchCard.vue?vue&type=template&id=079b826a&scoped=true&"
import script from "./AiJdMatchCard.vue?vue&type=script&lang=js&"
export * from "./AiJdMatchCard.vue?vue&type=script&lang=js&"
import style0 from "./AiJdMatchCard.vue?vue&type=style&index=0&id=079b826a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079b826a",
  null
  
)

export default component.exports